import { Controller } from "@hotwired/stimulus"

// Controls animation speed for preview/debugging
// Uses CSS custom property --animation-speed-multiplier
export default class extends Controller {
  static targets = ["preview", "speedBtn"]

  connect() {
    // Set initial speed to 1x
    this.currentSpeed = 1
    this.updateActiveButton()
  }

  setSpeed(event) {
    const multiplier = parseInt(event.currentTarget.dataset.speed, 10)
    this.currentSpeed = multiplier

    // Update CSS custom property directly on SVG elements
    this.previewTargets.forEach(preview => {
      const svgs = preview.querySelectorAll(".send-kindle-icon")
      svgs.forEach(svg => {
        svg.style.setProperty("--animation-speed-multiplier", multiplier)
      })
    })

    this.updateActiveButton()
  }

  playAnimation(event) {
    const button = event.currentTarget
    const svgs = button.querySelectorAll(".send-kindle-icon")

    svgs.forEach(svg => {
      // If already sending, ignore
      if (svg.classList.contains("sending")) return

      // Apply current speed multiplier
      svg.style.setProperty("--animation-speed-multiplier", this.currentSpeed)

      // Add class to trigger animation
      svg.classList.add("sending")

      // Remove class when animation ends so it can be triggered again
      const device = svg.querySelector(".send-kindle-device")
      if (device) {
        device.addEventListener("animationend", () => {
          svg.classList.remove("sending")
        }, { once: true })
      }
    })
  }

  updateActiveButton() {
    this.speedBtnTargets.forEach(btn => {
      const speed = parseInt(btn.dataset.speed, 10)
      if (speed === this.currentSpeed) {
        btn.classList.remove("btn--secondary")
        btn.classList.add("btn--primary")
      } else {
        btn.classList.remove("btn--primary")
        btn.classList.add("btn--secondary")
      }
    })
  }
}
